// Botões de link externo (Documentos e Aulas e Materiais). Mesma regra do
// backend (CreateExternalLinkDto): só https, com protocolo — o link vira href
// clicável na tela do cliente.
export function isHttpsUrl(value) {
 try {
  return new URL(value).protocol === 'https:';
 } catch {
  return false;
 }
}

export function hostDoLink(url) {
 try {
  return new URL(url).hostname;
 } catch {
  return url;
 }
}
